"use strict";

var React = require("react");
module.exports = React.createElement(
  "svg",
  { viewBox: "0 0 36 36" },
  React.createElement("path", { d: "M24.194 25.154c2.1-.429 6.515-2.615 6.515-9.387 0-7.2-4.844-11.53-11.53-11.53-7.587 0-13.759 5.1-13.759 14.4 0 6.472 2.915 10.93 8.015 13.545a.41.41 0 0 1 .214.386l-.085 2.832c0 .214-.043.214-.214.171A17.33 17.33 0 0 1 2.162 18.81c0-10.116 7.03-17.4 17.145-17.4 8.058 0 14.531 5.229 14.531 14.1 0 8.7-6.387 12.945-13.673 12.945-5.658 0-9.559-3.172-9.559-9.3A9.728 9.728 0 0 1 20.593 9.08a11.4 11.4 0 0 1 4.286.686c.171.043.214.086.214.257zm-2.272-13.116a5.751 5.751 0 0 0-1.757-.214c-3.943 0-6.429 3.129-6.429 7.072 0 3.729 1.972 6.687 6.087 6.687a5.313 5.313 0 0 0 1.329-.129z" })
);

